import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import { ProtectorListProps } from "../../../../store/model/calculations/protector";
import { useEffect, useState } from "react";
import useProtectorFacade from "../../../../facade/calculation/calculation-output/protector.facade";
import { ChevronArrowRight } from "../../../../assets/icons";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import { equipmentOptions } from "../../../../constants/columns/projectdetails/labelColumn";


const SelectedProtectorList: React.FC<ProtectorListProps> = ({ showError, setShowError }) => {

    const [upperEquipment, setUpperEquipment] = useState<any[]>([]);
    const [lowerEquipment, setLowerEquipment] = useState<any[]>([]);
    const [upperCollapse, setUpperCollapse] = useState<boolean>(false);
    const [lowerCollapse, setLowerCollapse] = useState<boolean>(false);
    const { selectedProtectorListCollapse } = useAppSelector((state) => state?.collapse);
    const {
        selectedLowerProtector,
        selectedUpperProtector,
        lowerEquipmentList,
        protectorSeries,
        upperEquipmentList,
        selectedLowerEquipment,
        selectedUpperEquipment,
    } = useAppSelector((state) => state?.protector)
    const { tab1Input } = useAppSelector((state) => state?.tubing);
        const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
        const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

    const { updateSelectedProtectorListCollapse } = useCollapseFacade();
    const {
        resetLowerProtector,
        resetUpperProtector,
        updateSelectedLowerEquipment,
        updateSelectedUpperEquipment,
    } = useProtectorFacade();

    const { updateSchematicEquipmentData } = useCalculationFacade();


    useEffect(() => {
        if (upperEquipmentList?.length > 0) {
            const updatedUpperEquipment = upperEquipmentList
                .filter((equipment: any) => {
                const matchesSeries =  equipment.series === selectedUpperProtector?.series;
                const selectedEquipmentOption = equipmentOptions.find(option => option.id === tab1Input?.catalogType?.toString());
                const isPermian = selectedEquipmentOption?.name === 'Permian';
                const isStandardized = isPermian ? equipment.standardization === true : true;
                return  matchesSeries && isStandardized;
        })
                ?.map((equipment: any) => ({
                    ...equipment,
                    value: equipment?.id,
                    label: equipment?.pN_Description,
                }));
            setUpperEquipment(updatedUpperEquipment || []);
        }
        if (lowerEquipmentList?.length > 0) {
            const updatedLowerEquipment = lowerEquipmentList
                .filter((equipment: any) => {
                    //const isLT = equipment.configuration === 'LT';
                    const matchesSeries = protectorSeries === '0' || equipment.series === selectedLowerProtector?.series;
                    const selectedEquipmentOption = equipmentOptions.find(option => option.id === tab1Input?.catalogType?.toString());
                    const isPermian = selectedEquipmentOption?.name === 'Permian';
                    const isStandardized = isPermian ? equipment.standardization === true : true;
                    return  matchesSeries && isStandardized;
                })
                .map((equipment: any) => ({
                    ...equipment,
                    value: equipment?.id,
                    label: equipment?.pN_Description,
                }));
        
            setLowerEquipment(updatedLowerEquipment || []);
        }
        
    }, [upperEquipmentList, lowerEquipmentList, protectorSeries]);

    const handleCollapseChange = (key: boolean) => {
        updateSelectedProtectorListCollapse(key);
    };

    const onLowerClear = () => {
        updateSelectedLowerEquipment([{}]);
        updateSchematicEquipmentData();
    };

    const onUpperClear = () => {
        updateSelectedUpperEquipment([{}]);
        updateSchematicEquipmentData();
    };

    const handleLowerRemove = () => {
        resetLowerProtector();
        updateSelectedLowerEquipment([{}]);
    }

    const handleUpperRemove = () => {
        resetUpperProtector();
        updateSelectedUpperEquipment([{}]);
    }

    const handleUpperCollapse = () => {
        setUpperCollapse(!upperCollapse);
    }

    const handleLowerCollapse = () => {
        setLowerCollapse(!lowerCollapse);
    }

    const handleChange = (selEquip: any, upperorlower: string) => {
      const equipmentArray = Array.isArray(selEquip) ? selEquip : [selEquip];
      if (upperorlower === "upper") {
        updateSelectedUpperEquipment([...equipmentArray]);
      } else {
        updateSelectedLowerEquipment([...equipmentArray]);
      }
      updateSchematicEquipmentData();
    };

    return (
        <>
            <Accordion
                title="Selected protectors list"
                isOpen={selectedProtectorListCollapse}
                onToggle={() => handleCollapseChange(!selectedProtectorListCollapse)}
                content={
                    <div className="p-[16px] flex flex-col">
                        <div className={`scrollable max-h-[400px] relative overflow-auto`}>
                            <table className="min-w-full rounded-[8px] outline-[1px] table">
                                <thead style={{ zIndex: 99 }}>
                                    <tr>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center"></div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Type</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Series</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Model</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Name</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Std shaft rating {tab1Input?.actNameProtector_ShaftRating || 'hp'}</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">HS shaft rating {tab1Input?.actNameProtector_ShaftRating || 'hp'}</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Power {tab1Input?.actNameProtector_ShaftRating || 'hp'}</div>
                                        </th>
                                        <th className="px-[24px] py-[16px] text-[12px] text-neutral-25">
                                            <div className="flex items-center">Remove</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <ChevronArrowRight
                                                onClick={() => {((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) && handleUpperCollapse() }}
                                                size={20}
                                                className={`${((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) ? "animate-pulse text-neutral-25 transition-transform duration-300 ease-in-out cursor-pointer": "cursor-not-allowed opacity-35 "} ${upperCollapse ? "rotate-90" : ""}`}
                                            />
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            Upper
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.series}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.model}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.name}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.stdShaftHP}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.hsShaftHP}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedUpperProtector?.hp}
                                        </td>
                                        {
                                            ((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) ?
                                            <td className="px-[24px] py-[16px] text-primary-400 font-semibold text-[14px] cursor-pointer" onClick={handleUpperRemove}>
                                                Remove
                                            </td>
                                            : <td className="px-[24px] py-[16px] text-primary-400 font-semibold text-[14px] cursor-pointer"></td>
                                        }
                                        
                                    </tr>
                                    {
                                        Object.keys(selectedUpperProtector)?.length > 0 && upperCollapse &&
                                        <tr>
                                            <td colSpan={9}>
                                                <EquipmentTableAddChargePump
                                                    options={upperEquipment || []}
                                                    equipments={selectedUpperEquipment?.length > 0 ? selectedUpperEquipment : [{}]}
                                                    onClear={onUpperClear}
                                                    onChange={(option: any) => handleChange(option, 'upper')}
                                                    rowLength={selectedUpperEquipment?.length || 1}
                                                    equipmentGridParentContainer="SRProtectorsUpper"
                                                />
                                            </td>
                                        </tr>
                                    }
                                    <tr>
                                        <td>
                                            <ChevronArrowRight
                                                onClick={() => {((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) && handleLowerCollapse()}}
                                                size={20}
                                                className={`${((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) ? "animate-pulse text-neutral-25 transition-transform duration-300 ease-in-out cursor-pointer" : "cursor-not-allowed opacity-35"} ${lowerCollapse ? "rotate-90" : ""}`}
                                            />
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            Lower
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.series}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.model}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.name}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.stdShaftHP}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.hsShaftHP}
                                        </td>
                                        <td className="px-[24px] py-[16px] text-neutral-25 text-[14px]">
                                            {selectedLowerProtector?.hp}
                                        </td>
                                        {
                                            ((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) &&
                                            <td className="px-[24px] py-[16px] text-primary-400 font-semibold text-[14px] cursor-pointer" onClick={handleLowerRemove}>
                                                Remove
                                            </td>
                                        }
                                        
                                    </tr>
                                    {
                                        Object.keys(selectedLowerProtector)?.length > 0 && lowerCollapse &&
                                        <tr>
                                            <td colSpan={9}>
                                                <EquipmentTableAddChargePump
                                                    options={lowerEquipment || []}
                                                    equipments={selectedLowerEquipment?.length > 0 ? selectedLowerEquipment : [{}]}
                                                    onClear={onLowerClear}
                                                    onChange={(option:any) => handleChange(option, 'lower')}
                                                    rowLength={selectedLowerEquipment?.length || 1}
                                                    equipmentGridParentContainer="SRProtectors"
                                                />
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export default SelectedProtectorList;
